export default "__VITE_ASSET__CUildop$__"